// extracted by mini-css-extract-plugin
module.exports = {"svg":"Pizza_svg__sqgau","black-overlay":"Pizza_black-overlay__KKvaM"};